import { styled } from 'goober';
import { forwardRef } from 'react';

export const MenuContainer = styled('div', forwardRef)<{ $offset?: number; $width?: number }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 6px;
    margin-left: ${(props) => (props.$offset ? `${props.$offset}px` : '')};
    background-color: ${({ theme }) => theme.colors.ui.white};
    width: ${(props) => (props.$width ? `${props.$width}px` : '300px')};
    border: 1px solid ${({ theme }) => theme.colors.neutral.w200};
    box-shadow: ${({ theme }) => theme.boxShadow};
    border-radius: 12px;
    box-shadow: 0px 4px 16px rgba(107, 131, 160, 0.15);
`;

export const MultiselectContainer = styled('div')`
    padding-left: 6px;
`;
